import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

const BEACON_ID = 'a2266e43-b09c-4c28-a43b-a7c80aaecf5a';

const HelpScoutBeacon = () => {
  useEffect(() => {
    if (Capacitor.isNativePlatform()) return;
    if (!window.Beacon) {
      window.Beacon = function (t, n, a) {
        window.Beacon.readyQueue.push({ method: t, options: n, data: a });
      };
      window.Beacon.readyQueue = [];
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://beacon-v2.helpscout.net';
      document.body.appendChild(script);
    }
    window.Beacon('init', BEACON_ID);

    return () => {
      try {
        window.Beacon('destroy');
      } catch (e) {
        // beacon not ready yet — nothing to destroy
      }
    };
  }, []);

  return null;
};

export default HelpScoutBeacon;
